<template>
  <v-container class="pa-0 fill-height" fluid>

    <v-fade-transition hide-on-leave>
      <template v-if="loading">
        <v-row align="center" class="fill-height" justify="center">
          <v-progress-circular size="64" indeterminate color="primary"/>
        </v-row>
      </template>
    </v-fade-transition>

    <v-navigation-drawer v-model="drawer"
                         :width="navDrawerWidth"
                         app
                         dark
                         class="chat-drawer"
                         location="left"
                         style="z-index: 203"
    >
      <div class="px-4 pt-4 pb-2 new-chat-button-holder grey darken-4">
        <v-btn outlined color="white lighten-1" block @click.stop="startNewChat">
          <v-icon left>mdi-chat-plus-outline</v-icon>
          Aloita uusi keskustelu
        </v-btn>
      </div>
      <v-list style="padding-top: 70px; padding-bottom: 41px;">
        <v-list-item-group v-model="activeChat">
          <v-slide-y-transition group>
            <template v-for="chat in pastChats">
              <v-list-item v-if="!chat.id.includes('dummy-')"
                           :key="chat.id"
                           :value="chat.id"
                           class="px-2"
                           @click.stop="viewChat(chat)">
                <v-list-item-avatar>
                  <v-icon color="secondary">mdi-message-text</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ chat.name }}</v-list-item-title>
                  <v-list-item-subtitle><small>{{ formatDate(chat.timestamp) }}</small></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-slide-y-transition>
        </v-list-item-group>
      </v-list>
      <div class="user-info-holder grey darken-4">
        <v-divider></v-divider>
        <v-list-item dense>
          <v-list-item-icon>
            <v-icon color="grey darken-1">mdi mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="caption">
              {{ user && user.email }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-navigation-drawer>

    <v-btn v-if="!drawer" color="primary" dark fab
           small
           fixed top right
           @click="showDrawer">
      <v-icon color="white">mdi-menu</v-icon>
    </v-btn>

    <template v-if="!loading">
      <v-row class="fill-height" justify="center" no-gutters>
        <v-slide-y-transition hide-on-leave>
          <v-col v-if="messages.length > 0" cols="12" style="padding-bottom: 150px;">
            <v-slide-x-transition group>
              <template v-for="(message, index) in formattedMessages">
                <div :key="message.index">
                  <chat-message-item :message="message"/>
                  <v-divider v-if="index < formattedMessages.length - 1" class="my-0 py-0 rowDivider"/>
                </div>
              </template>
            </v-slide-x-transition>
          </v-col>
        </v-slide-y-transition>
        <v-fade-transition hide-on-leave>
          <v-col v-if="messages.length === 0" class="fill-height" cols="12" lg="8" md="10" xl="6">
            <v-row align="center" class="fill-height" justify="center" no-gutters>
              <v-col class="mt-n15" cols="10" lg="6" md="6">
                <div class="text-h6 text-md-h4 accent2--text text-center">
                  Kysy meiltä mitä tahansa! Katsotaan kuinka <strong>voimme auttaa</strong>.
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-fade-transition>
      </v-row>


      <v-bottom-sheet :value="true" hide-overlay no-click-animation persistent :retain-focus="false">
        <v-container
            class="rowQuestion chat-input-holder" fluid>
          <v-row justify="center">
            <v-col cols="12" lg="10" md="10" xl="8">
              <v-row :style="{marginLeft: $vuetify.breakpoint.lgAndUp ? navDrawerWidth + 'px' : ''}">
                <v-col cols="12" md="10" offset-md="1">
                  <chat-input :loading="sendingMessage" :temperature="temperature" @submit="sendMessage"
                              @temperature="setTemperature" @start-new-chat="startNewChat"/>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.smAndUp" cols="12">
                  <v-row justify="center" no-gutters>
                    <div :style="{width: $vuetify.breakpoint.lgAndUp ? '50%' : '65%'}" class="my-n2">
                      <div class="caption accent2--text text-center">
                        Hallitse alla olevilla painikkeilla keskustelun korkealentoisuutta!
                      </div>
                      <div class="text-center mt-1 mb-2">
                        <v-btn-toggle v-model="temperature">
                          <v-btn small :color="temperature === 20 ? 'primary' : 'accent'"
                                 :class="temperature === 20 ? 'accent--text' : 'primary--text'" :value="20">Tarkempi
                          </v-btn>
                          <v-btn small :color="temperature === 50 ? 'primary' : 'accent'"
                                 :class="temperature === 50 ? 'accent--text' : 'primary--text'" :value="50">
                            Tasapainoisempi
                          </v-btn>
                          <v-btn small :color="temperature === 100 ? 'primary' : 'accent'"
                                 :class="temperature === 100 ? 'accent--text' : 'primary--text'" :value="100">Luovempi
                          </v-btn>
                        </v-btn-toggle>
                      </div>
                    </div>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-bottom-sheet>
    </template>

    <div id="chat-end"/>
  </v-container>
</template>

<script>
import ChatMessageItem from "@/views/Chat/components/ChatMessageItem";
import ChatInput from "@/views/Chat/components/ChatInput";
import {useStorage} from "@vueuse/core";
import chatApi from "@/api/chat-api";
import axios from "axios";
import store from "@/store";

let chatStorage;

export default {
  name: "ChatView",
  components: {ChatInput, ChatMessageItem},
  data() {
    return {
      messages: [],
      temperature: 20,
      loading: true,
      subtleLoading: true,
      sendingMessage: false,
      activeChat: null,
      chatId: null,
      drawer: this.$vuetify.breakpoint.lgAndUp,
      navDrawerWidth: 300,
      pastChats: [],
      user: null,
    };
  },
  computed: {
    formattedMessages() {
      let index = 0;
      return this.messages.flatMap(m => ([{
        id: `${m.id}-q`,
        type: 'question',
        message: m.message,
        index: index++,
      }, {
        id: `${m.id}-a`,
        type: 'reply',
        message: m.reply,
        index: index++,
      }]))
    }
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString('fi-FI', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      });
    },
    showDrawer() {
      this.drawer = true;
    },
    viewChat(chat) {
      this.chatId = chat.id;
      this.activeChat = chat.timestamp;
      this.reloadMessages();
    },
    async reloadMessages() {
      if (this.loading === false) {
        this.subtleLoading = true;
      } else {
        this.loading = true;
      }
      try {
        const messages = await chatApi.getChatMessages(this.chatId);
        messages.sort((a, b) => a.timestamp - b.timestamp);
        this.messages = messages || [];
        this.scrollToEnd();
      } catch (error) {
        alert(error);
      }
      this.loading = false;
      this.subtleLoading = false;
    },
    async sendMessage(messageText) {
      this.sendingMessage = true;
      if (this.chatId.startsWith('dummy')) {
        await this.createNewChat(messageText);
      }
      try {
        const previousMessage = this.messages.length > 0 ? this.messages[this.messages.length - 1] : null;

        const placeholderChatMessage = {
          id: 'placeholder',
          chat_id: this.chatId,
          message: messageText,
          timestamp: new Date(),
        };
        this.messages.push(placeholderChatMessage);
        this.scrollToEnd();
        const chatMessage = await chatApi.newChatMessage(this.chatId, {
          message: messageText,
          chatId: this.chatId,
          temperature: this.temperature / 100,
          chatMessage: previousMessage?.chat_message,
        });
        if (chatMessage) {
          Object.assign(this.messages[this.messages.length - 1], chatMessage);
        }
        this.scrollToEnd();
      } catch (error) {
        console.log(error);
      }
      this.sendingMessage = false;
    },
    scrollToEnd() {
      this.$nextTick(() => {
        this.$vuetify.goTo('#chat-end', {duration: 0});
      })
    },
    async reloadChats() {
      try {
        const chats = await chatApi.getChats();
        this.pastChats = chats.sort((a, b) => {
          return b.timestamp.getTime() - a.timestamp.getTime();
        }) || [];
      } catch (error) {
        alert(error);
      }
    },
    async startNewChat() {
      const timestamp = new Date().getTime();
      const dummyChat = {
        id: `dummy-${timestamp}`,
        name: 'Uusi keskustelu',
        timestamp: timestamp,
      };

      this.chatId = dummyChat.id;
      this.pastChats.unshift(dummyChat);
      this.activeChat = dummyChat.id;
      // await this.reloadMessages();
      this.messages = [];
    },
    async createNewChat(messageText) {
      try {
        const chat = await chatApi.newChat({name: messageText});
        this.chatId = chat.id;
        this.activeChat = chat.id;
        chatStorage.value.chatId = this.chatId;
        await this.reloadChats();
        await this.reloadMessages();
      } catch (error) {
        alert(error);
      }
    },
    setTemperature(value) {
      this.temperature = value;
    }
  },
  async mounted() {
    axios.defaults.headers.common['x-api-key'] = store.state.sessionId;

    await this.reloadChats();

    chatStorage = useStorage('chat-store', {chatId: null})


    if (chatStorage.value.chatId && this.pastChats.find(chat => chat.id === chatStorage.value.chatId)) {
      this.chatId = chatStorage.value.chatId;
      this.activeChat = this.chatId;
      console.log('use existingChat')
      this.reloadMessages();
    } else {
      console.log('startNewChat')
      this.startNewChat();
      this.loading = false;
    }

    this.$nextTick(() => {
      this.scrollToEnd();
    })
  }
}
</script>

<style lang="scss">
.chat-drawer {
  background-color: rgb(30, 30, 30) !important;
}

.chat-input-holder {
  -webkit-box-shadow: 0px -2px 16px 17px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px -2px 16px 17px rgba(204, 204, 204, 1);
  box-shadow: 0px -2px 16px 17px rgba(204, 204, 204, 1);
}

.new-chat-button-holder {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

.user-info-holder {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

#chat-end {
  position: absolute;
  bottom: 0;
}
</style>

